// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"styles_loadingSpinner__C8Zgs"};